import { undefinedOrTransformToDTOCurried } from '@maia/utils';

export class TeamDto {
  guid: string;
  name: string;

  constructor(team: TeamDto) {
    this.guid = team.guid;
    this.name = team.name;
  }
}

export const undefinedOrTeam = undefinedOrTransformToDTOCurried(
  (entity) => new TeamDto(entity),
);
